export default __webpack_public_path__ + "static/media/S-001.015729b5.png";